// extracted by mini-css-extract-plugin
export default {"rulesContainer":"styles_rulesContainer__CO7bw","ok":"styles_ok__Ljda3","error":"styles_error__AT5gI"};